import { IOption, createListFilters } from 'app/components'

export type SncrBlocosListFilters = {
  /** Empresa de vínculo médico: define a inscrição (CRM/UF) dos cards e da consulta. */
  empresa?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<SncrBlocosListFilters>({})
